
<style>
  .topbar-profile-badge {
    background-color: rgb(18, 0, 121);
    background: rgb(27, 37, 179);
  }

  #texto {
    position: absolute;
    margin-top: -30px;
  }

  .slim {
    place-content: center;
    display: flex;

  }

  .isNotSlim {
    justify-content: flex-end;
    margin-right: 8px;
    display: flex;
  }

  .slim a {
    transform: rotate(180deg);
    transition: all 0.6s ease-in;
  }

  .isNotSlim a {
    transform: rotate(0deg);
    transition: all 0.6s ease-in;
  }

  .animation-menu {
    transition: all 0.4s cubic-bezier(0.2, 0.77, 0.94, 0.97);
  }

  .imgSlim {
    max-width: 50px;
    transition: all 0.3s ease-in-out;
  }

  .imgNotSlim {
    max-width: 150px;
    transition: all 0.3s ease-in-out;
  }

  .img-user {
    display: flex;
    margin: 0 auto;

  }

  /* Works on Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: #b7b7b7 #f7f7f7;
  }

  /* Works on Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background: #f7f7f7;
  }

  *::-webkit-scrollbar-thumb {
    border: 3px solid #e8e8e8;
    background-color: #e9e9e9;
    border-radius: 7px;
  }


  .zoomOut {
    zoom: 1;
  }

  .menu-perfil-btn i {
    font-size: 1.4em;
  }



  .reasonButton:hover {
    color: #ff8301 !important;
    transition: all 0.3s ease-in-out;
  }

  .news-count {
    position: absolute;
    left: 49%;
    top: 87.3vh;
    background: red;
    padding: 2px 4px;
    border-radius: 100%;
    color: white;
    font-size: 11px;
    font-weight: 600;
  }

  .news-count-6ix-length {
    position: absolute;
    left: 41%;
    top: 86.1vh;
    background: rgb(255 0 0);
    padding: 2px 4px;
    border-radius: 100%;
    color: rgb(255 255 255);
    font-size: 11px;
    font-weight: 600;
  }

  .autorizacoes-count {
    position: absolute;
    left: 57%;
    top: 85.8vh;
    background: red;
    padding: 2px 4px;
    border-radius: 100%;
    color: white;
    font-size: 11px;
    font-weight: 600;
  }



</style>

<!-- <div class="layout-sidebar" (click)="app.onMenuClick($event)">
    <div class="layout-menu-title">MAIN MENU</div>
    <div class="menu-scroll-content">
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    </div>
</div> -->

<p-dialog [header]="'Alterar senha de ' + user?.login" [(visible)]="showTrocarSenha" [style]="{width: '20vw'}">
  <p-toast></p-toast>
  <div class="p-fluid p-grid">
    <div class="p-field p-col-12">
      <habil-label name="txtAtual" label="Senha Atual">
        <input type="password" name="txtAtual" pInputText [(ngModel)]="senhaAtual">
      </habil-label>
    </div>
    <div class="p-field p-col-12">
      <habil-label name="txtNova" label="Nova Senha">
        <input type="password" name="txtNova" pInputText [(ngModel)]="novaSenha">
      </habil-label>
    </div>
    <div class="p-field p-col-12">
      <habil-label name="txtConf" label="Confirmar Nova Senha">
        <input type="password" name="txtConf" pInputText [(ngModel)]="confirmarNovaSenha">
      </habil-label>
    </div>
  </div>
  <ng-template pTemplate="footer">
      <p-button icon="pi pi-check" (click)="salvarSenha()" label="Ok" styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>
<div class="layout-sidebar animation-menu cm-lateral" style="top: 0;"
  [class.cm-lateral-compacta]="app.menuLateralCompacto"
  [class.cm-lateral-hover]="app.menuLateralHover"
  [class.cm-lateral-grupo-aberto]="app.menuLateralNovo && app.grupoMenuAberto"
  (mouseenter)="app.entrarMenuLateral()"
  (mouseleave)="app.sairMenuLateral()"
  (click)="app.onMenuClick($event)">
  <div class="menu-scroll-content menu-lateral">
    <div class="cm-lateral-topo">
      <a class="cm-lateral-logo" target="_blank" href="https://www.habil.com.br" title="Abrir site do Hábil">
        <span class="cm-logo" role="img" aria-label="Central do Cliente Hábil">
          <span class="cm-logo-marca"></span>
          <span class="cm-logo-produto">Central do Cliente</span>
        </span>
      </a>
      <button *ngIf="app.menuLateralNovo"
        type="button"
        class="cm-lateral-botao cm-lateral-alternar"
        [title]="app.menuLateralRecolhido ? 'Fixar menu aberto' : 'Recolher menu'"
        (click)="app.alternarMenuLateral()">
        <i class="pi pi-bars"></i>
      </button>
    </div>
    <ul class="layout-menu">
      <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
    </ul>
    <div class="cm-lateral-usuario">
      <img *ngIf="showAvatar" [src]="getSrcImage()" alt="" class="cm-lateral-avatar" />
      <div class="cm-lateral-usuario-info">
        <span class="cm-lateral-usuario-nome">{{nomeUser}}</span>
        <span class="cm-lateral-usuario-detalhe">{{empresa || user?.login}}</span>
      </div>
    </div>
    <div class="cm-lateral-rodape">
      <button *ngFor="let item of visiveis(menuUsuario)"
        type="button"
        class="cm-lateral-botao"
        [title]="item.label"
        (click)="item.command()">
        <i [class]="item.icon"></i>
      </button>
    </div>
  </div>
  <div *ngIf="app.menuLateralNovo && app.grupoMenuAberto" class="cm-lateral-grupo">
    <div class="cm-lateral-grupo-titulo" (click)="app.grupoMenuAberto = null">
      <i class="pi pi-chevron-left"></i>
      <span>{{app.grupoMenuAberto.label}}</span>
    </div>
    <ul class="layout-menu">
      <li app-menuitem *ngFor="let child of app.grupoMenuAberto.items; let i = index;" [item]="child" [index]="i" [parentKey]="'grupo'"></li>
    </ul>
  </div>
</div>
